'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _pcSlateTools = require('./../../process/pc-slate-tools');

var _ShopifySection2 = require('../ShopifySection');

var _MobileMenu = require('./../../components/navigation/MobileMenu');

var _DesktopMenu = require('./../../components/navigation/DesktopMenu');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = '[data-header-container]'; /*
                                                     *  Header Section
                                                     *    Provides scripts for elements within the header section.
                                                     *
                                                     *  Version:
                                                     *    1.0.0 - 2020/02/26
                                                     */

var COUNTER_SELECTOR = '[data-header-cart-count]';
var CONTAINER_CART_DRAWER = '[data-show-cart-drawer]';
var CONTAINER_CART_CLOSE = '[data-close-cart-drawer]';
var CHECKOUT_BUTTON = '[data-cart-checkout]';
var BUTTON_MINUS = '[data-quantity-selector-minus]';
var BUTTON_PLUS = '[data-quantity-selector-plus]';
var REMOVE_BUTTON = '[data-remove-cart-item]';
var CONTAINER_OVERLAY = '[data-cart-drawer-overlay]';
var CLASS_HIDDEN = 'is-hidden';
var CLASS_MENU_OPEN = 'is-menu-open';
var QUANTITY_BOX = '[data-quantity-selector-field]';

var Header = function (_ShopifySection) {
  (0, _inherits3.default)(Header, _ShopifySection);

  function Header(container) {
    (0, _classCallCheck3.default)(this, Header);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, container));

    _this.container = container;
    _this.counter = container.find(COUNTER_SELECTOR);

    _this.mobileMenu = new _MobileMenu.MobileMenu(container.find(_MobileMenu.MOBILE_MENU_SELECTOR));
    _this.desktopMenu = new _DesktopMenu.DesktopMenu(container.find(_DesktopMenu.DESKTOP_MENU_SELECTOR));

    container.on('mouseenter', _DesktopMenu.DESKTOP_MENU_INNER, function () {
      return _this.onEnterMenu();
    });
    container.on('mouseleave', _DesktopMenu.DESKTOP_MENU_SELECTOR, function () {
      return _this.onExitMenu();
    });
    (0, _jquery2.default)(document).on(_pcSlateTools.ON_CART_FINISHED, function () {
      return _this.updateCounter();
    });
    container.on('click', CONTAINER_CART_DRAWER, function (e) {
      return _this.onShowCart(e);
    });
    (0, _jquery2.default)(document).on('click', CONTAINER_OVERLAY, function (e) {
      return _this.onCloseCart(e);
    });
    return _this;
  }

  (0, _createClass3.default)(Header, [{
    key: 'onShowCart',
    value: function onShowCart(e) {
      var _this2 = this;

      if ((0, _jquery2.default)(".c-cart-template").length) {
        window.location.href = '/cart';return;
      }
      e.preventDefault();
      e.stopPropagation();
      this.toggle_panel_visibility((0, _jquery2.default)('#cd-cart'), (0, _jquery2.default)('.c-modal__overlay'), (0, _jquery2.default)('body'));
      (0, _jquery2.default)(document).on(_pcSlateTools.ON_CART_FINISHED, function () {
        return _this2.getCart();
      });
      this.getCart();
      this.drawerLoading();
      (0, _jquery2.default)(document).on('click', REMOVE_BUTTON, function (e) {
        return _this2.removeItem(e);
      });
      (0, _jquery2.default)('#cd-cart').on('click', CONTAINER_CART_CLOSE, function (e) {
        return _this2.onCloseCart(e);
      });
      (0, _jquery2.default)('#cd-cart').on('click', BUTTON_MINUS, function (e) {
        return _this2.qtyProcess(e, 0);
      });
      (0, _jquery2.default)('#cd-cart').on('click', BUTTON_PLUS, function (e) {
        return _this2.qtyProcess(e, 1);
      });
      (0, _jquery2.default)('#cd-cart').on('click', CHECKOUT_BUTTON, function (e) {
        return _this2.goCheckout(e);
      });
      (0, _jquery2.default)('#cd-cart').on('change', QUANTITY_BOX, function (e) {
        return _this2.onChangeItem(e);
      });
    }
  }, {
    key: 'goCheckout',
    value: function goCheckout(e) {
      e.preventDefault();
      //e.stopPropagation();
      window.location.href = '/checkout';
    }
  }, {
    key: 'qtyProcess',
    value: function qtyProcess(e, t) {
      e.preventDefault();
      e.stopPropagation();
      (0, _jquery2.default)('body').addClass('loading');
      var self = (0, _jquery2.default)(e.currentTarget);
      var qty_field = self.closest("div").find("input[name=qty]");
      var qty = qty_field.val();
      if (t == 0) {
        if (qty > 1) qty--;else {
          self.attr("disabled", true);(0, _jquery2.default)('body').removeClass('loading');return false;
        }
      } else {
        self.closest("div").find(".is-minus").attr("disabled", false);
        qty++;
      }
      //qty_field.val(qty);
      this.updateItem(qty_field.data('index'), qty);
    }
  }, {
    key: 'onChangeItem',
    value: function onChangeItem(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = (0, _jquery2.default)(e.currentTarget);
      var q = self.val();
      var line = self.data('index');
      if (q < 1) {
        q = 1;self.val(q);
      }
      (0, _jquery2.default)('body').addClass('loading');
      this.updateItem(line, q);
    }
  }, {
    key: 'updateItem',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(line, quantity) {
        var _this3 = this;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _pcSlateTools.updateCart)(line, quantity);

              case 2:
                (0, _jquery2.default)(document).on(_pcSlateTools.ON_CART_FINISHED, function () {
                  return _this3.getCart();
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateItem(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return updateItem;
    }()
  }, {
    key: 'removeItem',
    value: function removeItem(e) {
      var _this4 = this;

      e.preventDefault();
      e.stopPropagation();
      var self = (0, _jquery2.default)(e.currentTarget);
      var line = e.currentTarget.dataset.cartRemoveVariant;
      (0, _jquery2.default)('body').addClass('loading');

      try {
        (0, _pcSlateTools.removeFromCart)(line);
        var qty = self.closest('[data-cart-item-container]').find('[data-quantity-selector-field]').val();
        var price = self.closest('[data-cart-item-container]').find('.cart-item__price').html();
        var name = self.closest('[data-cart-item-container]').find('.cart-item__title').html();
        var sku = self.closest('[data-cart-item-container]').find('.cart-item__code').html();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'page_type': 'remove_from_cart',
          'event': 'MagnetUK_remove_from_cart', //create a custom event in GTM
          'items': [{
            'item_id': sku.replace('Code: ', ''),
            'item_name': name,
            'price': price.replace(window.Currency.format.split('{')[0], ''),
            'item_brand': 'AMF Magnets',
            'quantity': qty
          }]
        });
        //e.currentTarget.closest("div.cart-item__container").remove();
      } catch (e) {
        console.error(e);
        if (e.description) alert(e.description);
        (0, _jquery2.default)('body').removeClass('loading');
        return;
      }

      (0, _jquery2.default)(document).on(_pcSlateTools.ON_CART_FINISHED, function () {
        return _this4.getCart();
      });
    }
  }, {
    key: 'onCloseCart',
    value: function onCloseCart(e) {
      (0, _jquery2.default)('.c-modal__overlay').hide();(0, _jquery2.default)('.cart-drawer__loading').remove();
      (0, _jquery2.default)(document).off('click', REMOVE_BUTTON);
      (0, _jquery2.default)('#cd-cart').off('click', CONTAINER_CART_CLOSE);
      (0, _jquery2.default)('#cd-cart').off('click', BUTTON_MINUS);
      (0, _jquery2.default)('#cd-cart').off('click', BUTTON_PLUS);
      (0, _jquery2.default)('#cd-cart').off('click', CHECKOUT_BUTTON);
      (0, _jquery2.default)('#cd-cart').off('change', QUANTITY_BOX);
      // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
      if ((0, _jquery2.default)('#cd-cart').hasClass('speed-in')) {
        (0, _jquery2.default)('#cd-cart').removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
          (0, _jquery2.default)('body').removeClass('overflow-hidden');
        });
      } else {
        (0, _jquery2.default)('#cd-cart').removeClass('speed-in');
      }
    }
  }, {
    key: 'drawerLoading',
    value: function drawerLoading() {
      (0, _jquery2.default)('#cd-cart').append((0, _jquery2.default)('<div>', { class: 'cart-drawer__loading' }).append((0, _jquery2.default)('<p>', { class: 'cart-drawer__loading-txt', text: 'Loading...' })));
    }
  }, {
    key: 'toggle_panel_visibility',
    value: function toggle_panel_visibility($lateral_panel, $background_layer, $body) {
      if ($lateral_panel.hasClass('speed-in')) {
        // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
        $lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
          $body.removeClass('overflow-hidden');
        });
        $background_layer.hide();
      } else {
        $lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
          $body.addClass('overflow-hidden');
        });
        $background_layer.show();
      }
    }
  }, {
    key: 'emptyCart',
    value: function emptyCart() {
      if ((0, _jquery2.default)(".c-cart-template").length) {
        var emptyWrap = (0, _jquery2.default)('<div>', { class: 'cart-empty__wrap' });
        emptyWrap.append((0, _jquery2.default)('<p>', { class: 'cart-empty__msg', text: 'Your cart is empty' }));
        emptyWrap.append((0, _jquery2.default)('<a>', { class: 'o-btn', text: 'Continue Shopping', href: '/' }));
        (0, _jquery2.default)('.c-cart-template').html(emptyWrap);
      } else {
        var emptyWrap = (0, _jquery2.default)('<p>', { class: 'cart-drawer__empty-txt', text: 'Your cart is empty' });
        (0, _jquery2.default)('.cart-drawer__container').html(emptyWrap);
      }
      (0, _jquery2.default)('body').removeClass('loading');
    }
  }, {
    key: 'getCart',
    value: function getCart() {
      var cart = (0, _pcSlateTools.getCurrentCart)(); //console.log(cart);
      var counter = 1;
      this.counter.html(cart.item_count);
      if (cart.item_count == 0) {
        this.emptyCart();return;
      }
      var h = (0, _jquery2.default)('<div>', { class: 'cart-drawer__header' });
      h.append((0, _jquery2.default)('<div>', { class: 'cart-drawer__header-title', text: 'Your Cart (' + cart.item_count + ')' }));
      var binner = (0, _jquery2.default)('<div>', { class: 'cart-drawer__body-inner' });
      cart.items.forEach(function (item, index) {
        var b1 = (0, _jquery2.default)('<button>', { class: 'o-quantity-selector__button is-minus', 'data-quantity-selector-minus': '', type: 'button' }).append((0, _jquery2.default)('<svg>', { class: 'o-quantity-selector__icon', viewBox: '0 0 11.16 1.8', xmlns: 'http://www.w3.org/2000/svg' }).append((0, _jquery2.default)('<path>', { d: 'm10.25 1.8h-9.35a.9.9 0 0 1 0-1.8h9.35a.9.9 0 0 1 .91.9.9.9 0 0 1 -.91.9z' })));

        var q1 = (0, _jquery2.default)('<div>', { class: 'o-quantity-selector__input', 'data-quantity-selector-field': '' }).append((0, _jquery2.default)('<input>', { class: 'o-quantity-selector__input-field o-input', 'data-index': item.id, type: 'text', value: item.quantity, name: 'qty', 'data-quantity-selector-field': '' }));

        var b2 = (0, _jquery2.default)('<button>', { class: 'o-quantity-selector__button is-plus', 'data-quantity-selector-plus': '', type: 'button' }).append((0, _jquery2.default)('<svg>', { class: 'o-quantity-selector__icon cust-svg-946959', viewBox: '0 0 22 22', xmlns: 'http://www.w3.org/2000/svg' }).append((0, _jquery2.default)('<g>', { fill: '#000' }).append((0, _jquery2.default)('<path>', { d: 'm11 .2c-.6 0-1 .4-1 1v9h-9c-.6 0-1 .4-1 1s.4 1 1 1h9v9c0 .6.4 1 1 1s1-.4 1-1v-9h9c.6 0 1-.4 1-1s-.4-1-1-1h-9v-9c0-.6-.4-1-1-1z', fill: '#000' }))));
        var qBox = (0, _jquery2.default)('<div>', { class: 'o-quantity-selector o-product-thumbnail__add-quantity' }).append((0, _jquery2.default)('<div>', { class: 'o-quantity-selector__inner' }).append(b1, q1, b2));
        var tBox = (0, _jquery2.default)('<div>', { class: 'cart-item__tool-wrap' }).append((0, _jquery2.default)('<a>', { class: 'cart-item__remove', 'data-cart-remove-variant': item.id, text: 'Remove', 'data-remove-cart-item': '' }), qBox);

        var itemDetails = (0, _jquery2.default)('<div>', { class: 'cart-item__details' }).append((0, _jquery2.default)('<p>', { class: 'cart-item__title', text: item.product_title }), (0, _jquery2.default)('<p>', { class: 'cart-item__code', text: 'Code: ' + item.sku }), tBox, (0, _jquery2.default)('<p>', { class: 'cart-item__price', text: (0, _pcSlateTools.formatMoney)(item.final_line_price, window.Currency.format) }));
        binner.append((0, _jquery2.default)('<div>', { class: 'cart-item__container', 'data-cart-item-container': '' }).append((0, _jquery2.default)('<div>', { class: 'cart-item__img' }).append((0, _jquery2.default)('<img>', { src: item.image, alt: '' })), itemDetails));
        counter++;
      });

      var b = (0, _jquery2.default)('<div>', { class: 'cart-drawer__body' }).append(binner);
      var f = (0, _jquery2.default)('<div>', { class: 'cart-drawer__footer' });
      f.append((0, _jquery2.default)('<div>', { class: 'cart-drawer__total', text: 'Subtotal: ' + (0, _pcSlateTools.formatMoney)(cart.total_price, window.Currency.format) }));
      f.append((0, _jquery2.default)('<button>', { class: 'o-btn cart-drawer__checkout-btn', text: 'Checkout', type: 'submit', 'data-cart-checkout': '' }));
      f.append((0, _jquery2.default)('<a>', { class: 'o-btn cart-drawer__cart-btn', text: 'Go to Cart', href: '/cart' }));
      //var miniCart = ;
      (0, _jquery2.default)('.cart-drawer__container').html('');
      (0, _jquery2.default)('.cart-drawer__container').append(h, b, f);
      // reload the whole div to load svg
      (0, _jquery2.default)("#cd-cart").html((0, _jquery2.default)("#cd-cart").html());
      (0, _jquery2.default)('body').removeClass('loading');
    }
  }, {
    key: 'onEnterMenu',
    value: function onEnterMenu() {
      this.container.addClass(CLASS_MENU_OPEN);
    }
  }, {
    key: 'onExitMenu',
    value: function onExitMenu() {
      this.container.removeClass(CLASS_MENU_OPEN);
    }
  }, {
    key: 'updateCounter',
    value: function updateCounter() {
      var cart = (0, _pcSlateTools.getCurrentCart)();
      this.counter.html(cart.item_count);
      this.counter.removeClass(CLASS_HIDDEN);

      if (cart.item_count <= 0) {
        this.counter.addClass(CLASS_HIDDEN);
      }
    }
  }]);
  return Header;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(CONTAINER_SELECTOR, Header);